import axiosInstance from "../utils/axios"

export const historyLogService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/data-log', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/data-log/' + id)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/data-log/${id}`)
      return response.data
    },
}